import HTTP from '../common/http-common';

const END_POINT = '/customer';

const listCustomer = () => HTTP.get(END_POINT);

const isExistCustomerCode = (customerCode, branchCode, customerId) => HTTP.get(END_POINT +  "/exist/" + customerCode + "/" + branchCode + "/" + customerId);
const insertCustomer = (data) => HTTP.post(END_POINT, {
    customerCode: data.customerCode,
    customerName: data.customerName,
    houseNo: data.houseNo,
    subdistrict: data.subdistrict,
    district: data.district,
    province: data.province,
    tel: data.tel,
    mobile: data.mobile,
    email: data.email,
    branchCode: data.branchCode,
    postCode: data.postCode
});
const updateCustomer = (data) => HTTP.post(END_POINT + "/" + data.customerId, {
    customerCode: data.customerCode,
    customerName: data.customerName,
    houseNo: data.houseNo,
    subdistrict: data.subdistrict,
    district: data.district,
    province: data.province,
    tel: data.tel,
    mobile: data.mobile,
    email: data.email,
    branchCode: data.branchCode,
    postCode: data.postCode
});

const deleteCustomer = (customerId) => HTTP.delete(END_POINT + "/" + customerId);

export {
    listCustomer,
    isExistCustomerCode,
    insertCustomer,
    updateCustomer,
    deleteCustomer
}